import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import styled from "styled-components"
import { LinkButton } from "Components"
import voca from "voca"
import { IconContext } from "react-icons"
import { FaBuilding } from "react-icons/fa"

import { mixins, Title, Subtitle } from "Styles"
import { theme } from "Theme"

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0;
  min-height: 140px;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    height: ${(props) => (props.image ? "auto" : "300px")};
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  position: relative;
  overflow: hidden;
  align-items: flex-end;
  justify-content: flex-end;
  ${(props) => (props.image ? "" : mixins.backgroundAfter)}
`

const Content = styled.div`
  color: ${theme.colors.white.base};
  font-weight: bold;
  z-index: 3;
  display: flex;
  flex-direction: ${(props) => (props.image ? "row" : "column")};
  text-align: flex-start;
  align-items: ${(props) => (props.image ? "center" : "flex-start")};
  max-width: ${theme.layout.base};
  padding: 1rem 4rem 1rem 1rem;
  width: 100%;
  position: absolute;
  .sponsor-logo {
    display: flex;
    img {
      margin: 0;
      margin-right: 1rem;
      width: auto;
    }
  }

  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 2rem;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const StyledImg = styled(GatsbyImage)`
  position: initial !important;
  img {
    filter: blur(10px);
  }
`

class HeaderImage extends React.Component {
  render() {
    const {
      title,
      sponsorType,
      subtitle,
      subtitle2,
      subtitle3,

      image,
      bgImage,
      optionsLink,
      sponsor,
      cta_url1,
      cta_url1_text,
    } = this.props
    const page = this

    return (
      <Wrapper image={bgImage}>
        {image && !sponsor && (
          <>
            <Content>
              {/* {title && title !== "null" && <Title className={!venue ? (!cta_url1 ? "mb-0" : "") : ""}>{title}</Title>} */}
              {title && title !== "null" && <Title className={""}>{title}</Title>}
              {subtitle && subtitle !== "null" && (
                <>
                  <Subtitle className={""}>
                    {subtitle}
                    {subtitle2 && subtitle2 !== "null" && (
                      <>
                        <br />
                        {subtitle2}
                        <br />
                        {subtitle3}
                      </>
                    )}
                  </Subtitle>
                </>
              )}

              {cta_url1 && cta_url1_text && optionsLink && (
                <>
                  <LinkButton
                    to={cta_url1}
                    track={page}
                    title={`${title} | ${cta_url1_text}`}
                    style={{ marginBottom: "0rem" }}>
                    {cta_url1_text}
                  </LinkButton>
                </>
              )}
            </Content>
            {image && (
              <GatsbyImage
                alt={""}
                title={title}
                image={image.childImageSharp.gatsbyImageData}
                style={{ position: "initial !important" }}
              />
            )}
          </>
        )}
        {image && sponsor && (
          <>
            <Content style={{ alignItems: "left", width: "100%" }}>
              {title && <Title style={{ marginBottom: "0" }}>{title}</Title>}
            </Content>
            <StyledImg alt={title} title={title} image={image.childImageSharp.gatsbyImageData} />
          </>
        )}
        {bgImage && sponsor && (
          <>
            <Content
              image={bgImage}
              style={{ color: "black", alignItems: "left", width: "100%", borderBottom: "1px solid #ddd" }}>
              <div className="sponsor-logo">
                <img src={bgImage} alt="" height={"100px"} width={"auto"} style={{ borderRadius: "8px" }} />
              </div>
              <div>
                {title && <Title>{title}</Title>}
                {sponsorType && (
                  <>
                    <Subtitle style={{ marginBottom: "0" }}>
                      <IconContext.Provider value={{ className: "react-icons" }}>
                        <FaBuilding />
                      </IconContext.Provider>
                      {`${voca.capitalize(sponsorType)}`}
                    </Subtitle>
                  </>
                )}
              </div>
            </Content>
          </>
        )}
      </Wrapper>
    )
  }
}

export default HeaderImage

HeaderImage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  image: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
}

HeaderImage.defaultProps = {
  children: false,
  image: false,
  title: false,
}
